/*
 * @Date: 2022-12-26 16:48:30
 * @LastEditTime: 2022-12-28 17:05:20
 * @Description:
 */
import Vue from 'vue'
import Router from 'vue-router'
import laout from '@/components/laout'
import login from './views/login.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
export default new Router({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes: [{
    path: '/login',
    component: login
  },
  {
    path: '/index',
    redirect: '/index/body1',
    component: laout,
    children: [{
      path: '/index/body1',
      meta: {
        title: '数据中心',
        icon: 'block'
      },
      component: () => import('@/views/body1')
    },
    {
      path: '/index/management',
      component: () => import('@/views/management')
    },
    {
      path: '/index/agent',
      component: () => import('@/views/agent')
    },
    {
      path: '/index/pay',
      component: () => import('@/views/pay')
    },
    {
      path: '/index/Order',
      name: 'Order',
      component: () => import('@/views/Order')
    },
    {
      path: '/index/Payment_details',
      name: 'Payment_details',
      component: () => import('@/views/Payment_details')
    },
    {
      path: '/index/update_password',
      name: 'update_password',
      component: () => import('@/views/update_password')
    },
    {
      path: '/index/copyright',
      name: 'copyright',
      component: () => import('@/views/copyright')
    },
    {
      path: '/index/page_component',
      component: () => import('@/views/page_component')
    },
    {
      path: '/index/storeLocation',
      component: () => import('@/views/storeLocation')
    }
    ]
  }
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue")
    // }
  ]
})
